import React from 'react';
import { View, Text, TouchableOpacity, Image } from 'react-native';
import { Feather } from '@expo/vector-icons';
import styles from './styles/styles'; // Shared styles from sidebar/header

const Header = ({ onToggleSidebar, scrollY }) => {
  const showLogo = scrollY && scrollY.__getValue() > 10;
  return (
    <View style={styles.header}>
       {/* Left: Logo or Text */}
    <TouchableOpacity
      onPress={() => window.location.href = '/'}
      style={{ flexDirection: 'row', alignItems: 'center' }}
    >
      <Image
        source={require('./assets/logo.png')}
        style={{ width: 30, height: 30, resizeMode: 'contain' }} // ⬅️ make smaller and square
      />

      <Text style={[styles.logoTitle, { marginLeft: 4 }]}>  {/* ⬅️ reduce left margin */}
        IntegrationX
      </Text>
    </TouchableOpacity>


      {/* Right: Sidebar Toggle */}
      <TouchableOpacity
        style={styles.sidebarIconContainer}
        onPress={onToggleSidebar}
      >
        <View style={styles.sidebarIconWrapper}>
          <Feather name="sidebar" size={22} color="#fff" />
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default Header;
